<template>
  <div class="login">
    <div class="login__header">
      <div class="login__header-img">
        <img src="@/assets/img/vlLogo_color_noBG.png" alt="" />
      </div>
    </div>
    <div class="login__body">
      <div v-if="$store.getters.loading" class="loadingAnimationDiv">
        <MoonLoader class="loadingSVG" />
        <div v-if="$store.getters.longLoadingTime" class="longLoadingText">
          {{ $t('longLoadingNotice') }}
        </div>
      </div>
      <div v-else>
        <form action="#" class="form" @submit.prevent="validate()">
          <div class="form__group">
            <input
              type="text"
              class="form__input"
              :placeholder="$t('username')"
              id="username"
              required
              value="username"
              autocomplete="username"
              autofocus
              v-model="form.username"
            />
            <label for="username" class="form__label">{{ $t('username') }} / {{ $t('email') }}</label>
          </div>
          <div class="form__group u-margin-bottom-small">
            <input
              type="password"
              class="form__input"
              :placeholder="$t('password')"
              id="password"
              required
              name="password"
              v-model="form.password"
              autocomplete="current-password"
            />
            <label for="password" class="form__label">{{ $t('password') }}</label>
          </div>

          <div class="form__group">
            <div v-if="$store.getters.failedLoginAttempt">
              <div class="form__error">{{ $t('invalidCredentials') }}</div>
            </div>

            <div class="form__button-submit">
              <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="siteKey"
                @verify="submitForm"
                @expired="onCaptchaExpired"
              >
                <button type="submit" class="btnCustom btnCustom-lg btnCustom__confirm">
                  {{ $t('signIn') }} &rarr;
                </button>
              </vue-recaptcha>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import SvgLoader from '../../components/svg/SvgLoader';
import MoonLoader from '../../components/svg/SvgLoaderMoon';
export default {
  name: 'Login',
  components: {
    MoonLoader,
    SvgLoader,
    VueRecaptcha,
  },
  data: function () {
    return {
      form: {
        username: '',
        password: '',
        'g-recaptcha-response': '',
      },
      siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      info: '',
      errors: null,
      contact: null,
    };
  },
  methods: {
    async submitForm(recaptchaToken) {
      this.form['g-recaptcha-response'] = recaptchaToken;
      let user = await this.$store.dispatch('login', this.form);
      if (user)
        this.$gtag.config({
          user_id: user.user_id,
        });
    },
    validate() {
      this.$refs.recaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>
<style scoped>
.loadingAnimationDiv {
  margin-top: 5rem;
  text-align: center;
}
.loadingSVG {
  margin: 0px auto;
  display: flex;
  justify-content: center;
  width: 100%;
}
.longLoadingText {
  text-align: center;
  margin-top: 2rem;
  font-size: 1.6rem;
}
</style>
